class ExposeMap {
    constructor(element) {
        this.element = element;
        this.detailWrapper = $('.I-js-expose-map-details');
        this.placeButtons = $('.I-js-expose-map-place-button');
        this.mapCollapseButton = $('.I-js-expose-map-collapse');
        this.markers = {};
        this.markerIcons = {
            bakery: {
                url: '/immobilien/image/maps/gmaps_marker_bakery.png',
                scaledSize: new window.google.maps.Size(38, 38),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(19, 19),
            },
            school: {
                url: '/immobilien/image/maps/gmaps_marker_school.png',
                scaledSize: new window.google.maps.Size(38, 38),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(19, 19),
            },
            doctor: {
                url: '/immobilien/image/maps/gmaps_marker_doctor.png',
                scaledSize: new window.google.maps.Size(38, 38),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(19, 19),
            },
        };

        this.geocoder = new window.google.maps.Geocoder();
        const address = this.element.data('adress');
        this.addressIsPrecise = this.element.data('address-precise');

        this.mapOptions = {
            center: undefined,
            zoom: this.addressIsPrecise ? 16 : 13,
        };

        if (this.element.length > 0) {
            this.bindEvents();

            this.getGeocodeInformationOfAddress(address).then((result) => {
                this.mapOptions.center = result[0].geometry.location;
                this.renderMap(this.mapOptions);
            }).catch((status) => {
                // catch Maps error
                /* eslint-disable no-console */
                console.log(status);
            });
        }
    }

    static loadGoogleMapsApi(apiKey) {
        if (typeof window.google === 'undefined') {
            /* eslint-disable-next-line */
            $.getScript(`https://maps.google.com/maps/api/js?key=${apiKey}&sensor=false&libraries=places&callback=iCallbackGoogleMapsIsLoaded`);
        }
    }

    renderMap(mapOptions) {
        this.map = new window.google.maps.Map(document.getElementById('I-js-expose-map'), mapOptions);

        if (this.addressIsPrecise) {
            this.mainMarker = new window.google.maps.Marker({
                map: this.map,
                zoom: 16,
                icon: {
                    url: '/immobilien/image/maps/gmaps_marker.png',
                    scaledSize: new window.google.maps.Size(70, 70),
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(35, 35),
                },
                position: mapOptions.center,
            });
        }
    }

    bindEvents() {
        this.placeButtons.on('click', event => this.handlePlaceButtonClicked(event));

        this.mapCollapseButton.on('click', () => this.handleCollapseClicked());
    }

    getGeocodeInformationOfAddress(address) {
        return new Promise((resolve, reject) => {
            this.geocoder.geocode({address}, (results, status) => {
                if (status === window.google.maps.GeocoderStatus.OK) {
                    resolve(results);
                } else {
                    reject(status);
                }
            });
        });
    }

    handlePlaceButtonClicked(event) {
        const element = $(event.currentTarget);
        const placeClicked = element.data('place');

        if (element.hasClass('active')) {
            this.hidePlacesOfType(placeClicked);
        } else if (this.markers[placeClicked] === undefined) {
            // Daten abrufen
            this.getPlacesOfType(placeClicked).then((results) => {
                const newMarkers = [];

                results.forEach((result) => {
                    const newMarker = this.buildNewMarker(result, placeClicked);
                    newMarkers.push(newMarker);
                });

                this.markers[placeClicked] = newMarkers;
            }).catch((status) => {
                /* eslint-disable no-console */
                console.log(status);
            });
        } else {
            // Daten aus array
            this.showPlacesOfType(placeClicked);
        }

        element.toggleClass('active');
    }

    hidePlacesOfType(type) {
        this.markers[type].forEach((marker) => {
            marker.setMap(null);
        });
    }

    showPlacesOfType(type) {
        this.markers[type].forEach((marker) => {
            marker.setMap(this.map);
        });
    }

    getPlacesOfType(type) {
        if (this.placesService === undefined) {
            this.placesService = new window.google.maps.places.PlacesService(this.map);
        }

        return new Promise((resolve, reject) => {
            this.placesService.nearbySearch({
                location: this.mapOptions.center,
                radius: 5000,
                type: [type],
            }, (result, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    resolve(result);
                } else {
                    reject(status);
                }
            });
        });
    }

    buildNewMarker(place, type) {
        return new window.google.maps.Marker({
            position: place.geometry.location,
            map: this.map,
            icon: this.markerIcons[type],
        });
    }

    handleCollapseClicked() {
        this.detailWrapper.toggleClass('hidden');
        this.mapCollapseButton.toggleClass('hidden');
        this.element.toggleClass('big');

        const currCenter = this.map.getCenter();
        window.google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(currCenter);
    }
}

const iExposeMap = {
    element: $('#I-js-expose-map'),

    callbackMapIsLoaded() {
        this.exposeMap = new ExposeMap(iExposeMap.element);
    },

    init() {
        if (window.iGoogleMapsApiKey !== undefined) {
            ExposeMap.loadGoogleMapsApi(window.iGoogleMapsApiKey);
            window.iCallbackGoogleMapsIsLoaded = this.callbackMapIsLoaded;
        }
    },
};


export default iExposeMap;
